export const options = {
  kind: [
    { value: '0', label: 'Snapshot' },
    { value: '1', label: 'Timeseries' },
  ],
  frequency: [
    { value: 'D', label: 'Daily' },
    { value: 'W', label: 'Weekly' },
    { value: 'M', label: 'Monthly' },
    { value: 'Q', label: 'Quarterly' },
    { value: 'Y', label: 'Yearly' },
    { value: '7D', label: '7 days' },
    { value: '7DPAD', label: '7 days padded' },
    { value: '7DME', label: '7 days (middle eastern)' },
    { value: '7DMEPAD', label: '7 days padded (middle eastern)' },
  ],
  startEnd: [
    { value: 'SeriesTerms', label: 'Series Terms', isCaption: true },
    { value: 'LATESTDATE', label: 'Latest date' },
    { value: 'TODAY', label: 'Intraday' },
    { value: 'TIME', label: 'Series end' },
    { value: 'BDATE', label: 'Base date' },
    { value: 'PeriodTerms', label: 'Period Terms', isCaption: true },
    { value: 'D', label: 'Days' },
    { value: 'W', label: 'Weeks' },
    { value: 'M', label: 'Months' },
    { value: 'Q', label: 'Quarters' },
    { value: 'Y', label: 'Years' },
    { value: 'WKS', label: 'Start of week' },
    { value: 'MTS', label: 'Start of month' },
    { value: 'QTS', label: 'Start of quarter' },
    { value: 'YRS', label: 'Start of year' },
    { value: 'WKM', label: 'Middle of week' },
    { value: 'MTM', label: 'Middle of month' },
    { value: 'QTM', label: 'Middle of quarter' },
    { value: 'YTM', label: 'Middle of year' },
    { value: 'WKE', label: 'End of week' },
    { value: 'MTE', label: 'End of month' },
    { value: 'QTE', label: 'End of quarter' },
    { value: 'YRE', label: 'End of year' },
  ],
}
